export const CREATE_POOL_REQUEST_SUCCESS = 'CREATE_POOL_REQUEST_SUCCESS';

export const createPoolRequestSuccess = ({ poolRequest }) => ({
    type: CREATE_POOL_REQUEST_SUCCESS,
    payload: {
        poolRequest,
    }
});
